/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col, Button, Modal, Checkbox, message, DatePicker,Empty, Input, Radio, Select, Tabs} from 'antd';
import BaseComponent from "../../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
const {Option} = Select;
const dateFormat = 'YYYY-MM-DD';
const { Search } = Input;

export default class AddModal extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            allDepartmentsData:[],
            showSelectMediaData:true,
            modalList:[],
            searchText:'',
            departId:undefined,//选择单位
            checkMediaCodes:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        if (this.permissionCheck("pms:positionManage:all")) {
            this.getDeptAll()
        }else{
            this.getCurrentDeptByIds()
        }

    }
    //获取全部单位
    getDeptAll = ( ) =>{
        this.request({
            url: "/cm-sites-sys/dept/getAll",
            method:"GET",
            callBack: (res) => {
                if(res){
                    this.setState({allDepartmentsData:res})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

  //获取自己所在单位
    getCurrentDeptByIds = () =>{
        this.request({
            url: "/cm-sites-sys/dept/getByIds",
            contentType: "json",
            body: window.top.currentUser.deptIds,
            method:"post",
            callBack: (res) => {
                if(res){
                    this.setState({allDepartmentsData:res})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

   //获取媒体列表
    getMediaList = () =>{
        this.request({
            url: this.props.currentData.newMediasUrl,
            contentType: "json",
            body:{
                deptIds:this.state.departId?[this.state.departId]:null,
                grade:this.props.currentTabs?this.props.currentTabs:null,
                keyWord:this.state.searchText?this.state.searchText:null
            },
            method:"post",
            callBack: (res) => {
                let modalList = [];
                if(res&&res.length){
                   res.forEach((item,index)=>{
                       this.props.checkMediaCodes.forEach((i,ids)=>{
                           if(item.code === i){
                               item.checked =true
                           }
                       })
                   });
                    modalList = res
                }
                this.setState({modalList})
            },
            errorCallBack: (e) => {
            },
        })
    };

    revert = () =>{
        this.state.searchText = '';
        this.state.departId = undefined;
        this.setState({},()=>{
            this.getMediaList()
        })
    };

    show = () =>{
        this.state.searchText = '';
        this.state.departId = undefined;
        this.state.visible =true;
        this.state.checkMediaCodes = this.props.checkMediaCodes;
        this.setState({});
        this.getMediaList();
    };
    clickChecked(record, i) {
        record.checked = !record.checked;
        if( record.checked ) {
            this.state.checkMediaCodes.push(record.code)
        } else{
            this.state.checkMediaCodes =  this.state.checkMediaCodes.filter(item =>item !== record.code)
        }
       this.setState({})
    }
    onOK = () =>{
        if(!this.state.checkMediaCodes.length){
            this.request({
                url: this.props.currentData.newMediasUrl,
                contentType: "json",
                body:{
                    deptIds:null,
                    grade:this.props.currentTabs?this.props.currentTabs:null,
                    keyWord:null
                },
                method:"post",
                callBack: (res) => {
                    if(res&&res.length){
                        res.forEach((item,index)=>{
                           this.state.checkMediaCodes.push(item.code)
                        });
                        this.props.callBack&&this.props.callBack(this.state.checkMediaCodes)
                    }
                },
            })
        }else{
            this.props.callBack&&this.props.callBack(this.state.checkMediaCodes)
        }
        this.state.visible = false;
        this.setState({})

    };
    render() {
        return (
            <Modal
                title="选择媒体"
                visible={this.state.visible}
                destroyOnClose={true}
                maskClosable={false}
                keyboard={false}
                centered
                onOk={() => {
                    this.onOK();
                }}
                onCancel={() => {
                    this.setState({
                        visible: false,
                    });
                }}
                width={800}
            >
                <Row>
                    <Col span={8}>
                        <div style={{paddingLeft: 30}}>
                            <div style={{
                                width: 160, height: 30,
                                lineHeight: '30px'
                            }}>
                                <Select
                                    value={this.state.departId}
                                    style={{width: 220}}
                                    placeholder="请选择单位"
                                    allowClear
                                    onChange={(e) => {
                                        this.state.departId = e;
                                        this.setState({},()=>{
                                            this.getMediaList()
                                        })
                                    }}>
                                    {this.state.allDepartmentsData&&this.state.allDepartmentsData.length&&this.state.allDepartmentsData.map((item, i) => {
                                        return (
                                            <Option title={item.name} key={i} value={item.id}>{item.name}</Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{paddingLeft: 30, paddingRight: 20}}>
                            <Search
                                style={{
                                    height: 30,
                                    lineHeight: '30px'
                                }}
                                placeholder="请输入账号名称"
                                size="default"
                                allowClear
                                value={this.state.searchText}
                                onChange={(e) => {
                                    this.setState({
                                        searchText: e.target.value
                                    });
                                }}
                                onSearch={value => {
                                  this.getMediaList()
                                }}
                            />
                        </div>

                    </Col>
                    <Col span={4}>
                        <div>
                            <Button style={{
                                height: 30,
                                lineHeight: '30px'
                            }} onClick={() => {
                                this.revert();
                            }} size={'default'}>重置</Button>
                        </div>
                    </Col>
                </Row>
                <div style={{padding: "20px 20px 0px 20px"}}>
                        <Scrollbars autoHide autoHeight autoHeightMax={445}>
                            <div>
                                {this.state.modalList && this.state.modalList.length > 0 && this.state.modalList.map((item, index) => {

                                    return (
                                        <div key={index}  onClick={() => {
                                            this.clickChecked(item, index);
                                        }}  style={{
                                            width: 220,
                                            height: 50,
                                            lineHeight: '50px',
                                            border: '1px solid #ececec',
                                            paddingLeft: 20,
                                            float: 'left',
                                            marginTop: 10,
                                            marginLeft: 10,
                                        }}>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-around",
                                                alignItems: "center",
                                                cursor: "pointer"
                                            }}>
                                                <div style={{marginRight: "5px"}}>
                                                    <Checkbox checked={item.checked}/>
                                                </div>
                                                <div style={{
                                                    width: "220px", overflow: 'hidden',
                                                    textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                                }}
                                                     title={item.name}>{item.name}</div>
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </Scrollbars>

                </div>
            </Modal>
        )
    }

}